<label class="form-zone-label">Zones de recherche *</label>
<fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="criteriaSearchZonesTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>
<div class="drag-and-drop-container drop-list-container">
    <div
        cdkDropList
        #selectedList="cdkDropList"
        [cdkDropListData]="selectedItems"
        class="selected-list drop-list"
        [ngClass]="{ 'drop-list-disabled': disabled, 'selected-list-disabled': disabled }"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListDisabled]="disabled">
        @for (item of selectedItems; track item) {
            <div class="selected-item drop-item" [ngClass]="{ 'selected-item-disabled': disabled }" cdkDrag cdkDragPreview cdkDragBoundary=".selected-list">
                @if (!disabled) {
                    <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                }
                <span class="label">{{ item.text }}</span>
                @if (!disabled) {
                    <fa-icon
                        [icon]="faDelete"
                        class="fa-1x default-box-icon"
                        [ngClass]="{ 'fa-lg': true, 'drag-item-action': true, 'fa-disabled': false }"
                        (click)="onRemoveSearchZone(item)"></fa-icon>
                }
            </div>
        }
    </div>

    @if (!disabled && unusedItems.length > 0) {
        <div
            cdkDropList
            #unusedList="cdkDropList"
            [cdkDropListData]="unusedItems"
            [cdkDropListConnectedTo]="[selectedList]"
            class="unused-list drop-list"
            (cdkDropListDropped)="drop($event)"
            [cdkDropListDisabled]>
            @for (item of unusedItems; track item) {
                <div class="unused-item drop-item" cdkDrag cdkDragPreview>
                    <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                    <span class="label">{{ item.text }}</span>
                </div>
            }
        </div>
    }
</div>
